import React from "react";
import { FC, useState } from "react";
import { SvgIcon } from "../../../SvgIcon/SvgIcon";

type CalendarArrowProps = {
  direction?: "prev" | "next";
  ariaLabel?: string;
  loading?: boolean;
};

export const CalendarArrow: FC<CalendarArrowProps> = ({
  direction,
  ariaLabel,
  loading,
}) => {
  return (
    <>
      {direction === "prev" ? (
        <SvgIcon
          iconName="arrow-left-calendar"
          aria-label={ariaLabel || ""}
          className={loading ? "calendar-arrow--disabled" : ""}
        />
      ) : (
        <SvgIcon
          iconName="arrow-right-calendar"
          aria-label={ariaLabel || ""}
          className={loading ? "calendar-arrow--disabled" : ""}
        />
      )}
    </>
  );
};
